
<form *ngIf="processorFormGroup" [formGroup]="processorFormGroup">
  <div class="card mt-2 ">
    <div class="grid">
      <div class="col-6">
        <!--<div class="flex flex-wrap gap-2">-->
        <div class="input-field">
          <label for="name">Tramitador *</label>
          <p-dropdown 
            name="processorId"
            [options]="processors"             
            optionLabel="name" 
            optionValue="id"
            [filter]="true"
            filterBy="name"             
            placeholder="Seleccione tramitador"
            appendTo="body"             
            formControlName="processorId" d-form-field-error/>            
        </div>        
      </div>
      <div class="col-6">
        <!--<div class="flex flex-wrap gap-2">-->
        <div class="input-field">
          <label for="maxLoadChargePercent">% de carga *</label>
          <p-inputNumber 
            name="maxLoadChargePercent"            
            inputId="percent" 
            suffix="%" 
            [min]="0" 
            [max]="100"
            formControlName="maxLoadChargePercent" d-form-field-error/>            
        </div>        
      </div>
    </div>
    <div class="grid">
      <div class="col-3">
        <!--<div class="flex flex-wrap gap-2">-->
        <div class="input-field">
          <label for="vipCase">Expediente VIP</label>
          <p-dropdown 
            name="vipCase"
            [options]="vipsCase"             
            optionLabel="name" 
            optionValue="id"
            appendTo="body"             
            formControlName="vipCase" d-form-field-error/>            
        </div>        
      </div>

      <div class="col-6">
        <!--<div class="flex flex-wrap gap-2">-->
        <div class="input-field">
          <label for="name">Tipo de daño</label>
           <p-multiSelect [ngModelOptions]="{standalone: true}" [options]="casesTypes" [(ngModel)]="selectedCasesTypes"
                placeholder="Todos" optionLabel="name" display="chip" appendTo="body"
                optionValue="id"  [maxSelectedLabels]="selectedCasesTypes!=null?selectedCasesTypes.length:5"
                showClear (onChange)="sortSelectedCasesTypes()" />        
        </div> 
   
      </div>
    </div>    
  <div class="grid">
    <div class="col-6">
      <div class="input-field">
        <label for="enableIncomingCalls">Recibir llamadas</label>
        <p-inputSwitch formControlName="enableIncomingCalls" d-form-field-error></p-inputSwitch>
      </div>
    </div>
    <div class="col-6">
      <!--<div class="flex flex-wrap gap-2">-->
      <div class="input-field">
        <label for="allowWithoutCaseType">Sin tipo de daño</label>
        <p-checkbox formControlName="allowWithoutCaseType" [binary]="true"></p-checkbox>          
      </div>        
    </div>    
  </div>
    
    <div class="mt-6 flex gap-2 justify-content-end ">
      <p-button label="Eliminar" *ngIf="contractProcessor.id&&allowDelete" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"></p-button>
      <div class="flex-grow-1"></div>
      <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
      <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>
  </div>
</form>  

